import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking, Platform, Modal, TextInput, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { colores, layout } from '../../../styles/variablesCss';

const Footer = () => {
  const navigation = useNavigation();
  const [showArrepModal, setShowArrepModal] = React.useState(false);
  const [nombre, setNombre] = React.useState('');
  const [contacto, setContacto] = React.useState('');
  const [pedido, setPedido] = React.useState('');
  const [enviando, setEnviando] = React.useState(false);
  const [enviado, setEnviado] = React.useState(false);
  const [error, setError] = React.useState('');
  
  // Detectar si estamos en móvil y obtener dimensiones de pantalla
 // const isMobile = PlatformDetector.isMobile();
 // const screenWidth = Dimensions.get('window').width;
 // const isSmallScreen = screenWidth < 600;

  const handleNavigation = (route) => {
    navigation.navigate(route);
  };

  const openArrepentimiento = () => {
    setShowArrepModal(true);
  };

  const closeArrepentimiento = () => {
    setShowArrepModal(false);
    setEnviado(false);
    setEnviando(false);
    setError('');
    setNombre('');
    setContacto('');
    setPedido('');
  };

  const handleEnviarArrep = async () => {
    setError('');
    if (!nombre.trim() || !contacto.trim() || !pedido.trim()) {
      setError('Completá todos los campos.');
      return;
    }
    setEnviando(true);
    try {
      const mail = encodeURIComponent(contacto);
      const subject = encodeURIComponent('Confirmación de arrepentimiento de compra');
      const body = encodeURIComponent(
        `Hola ${nombre},\n\nRecibimos tu solicitud de arrepentimiento de compra.\nNúmero de pedido/comprobante: ${pedido}.\n\nProcederemos a dar de baja el pedido y a gestionar la devolución. Verás la acreditación en unas horas.\n\nGracias.\nEquipo de Supermercados Pingüino`
      );
      const mailtoUrl = `mailto:${mail}?subject=${subject}&body=${body}`;
      if (Platform.OS === 'web') {
        window.open(mailtoUrl, '_blank');
      } else {
        await Linking.openURL(mailtoUrl);
      }
    } catch (e) {
      // Continuar igualmente
    }
    setEnviando(false);
    setEnviado(true);
  };

  const handleOpenSucursales = () => {
    const mapsUrl = 'https://www.google.com.ar/maps/search/supermercados+pinguino';
    if (Platform.OS === 'web') {
      window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    } else {
      Linking.openURL(mapsUrl).catch(() => {});
    }
  };

  const handleOpenCV = () => {
    const cvUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSeTfwuJfL1LcdX8qPZPpWBhr9d0QngghW3OnC84jQyzKirjFg/viewform?usp=preview';
    if (Platform.OS === 'web') {
      window.open(cvUrl, '_blank', 'noopener,noreferrer');
    } else {
      Linking.openURL(cvUrl).catch(() => {});
    }
  };

  const handleOpenGiftcard = () => {
    const pdfUrl = 'https://www.pinguino.com.ar/static/GiftCartVyC.pdf';
    if (Platform.OS === 'web') {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    } else {
      Linking.openURL(pdfUrl).catch(() => {});
    }
  };

  return (
    <View style={styles.wrapper}>
      {/* Borde superior rojo */}
      <View style={styles.topBorder} />

      {/* Zona oscura principal */}
      <View style={styles.darkArea}>
        {/* Enlaces centrados con separadores */}
        <View style={styles.linksRow}>
          <TouchableOpacity onPress={() => handleNavigation('Manifiesto')}>
            <Text style={styles.linkText}>MANIFIESTO</Text>
          </TouchableOpacity>
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={() => handleNavigation('Historia')}>
            <Text style={styles.linkText}>HISTORIA</Text>
          </TouchableOpacity>
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={handleOpenSucursales}>
            <Text style={styles.linkText}>SUCURSALES</Text>
          </TouchableOpacity>
           {/*<Text style={styles.sep}>·</Text>
         <TouchableOpacity onPress={() => handleNavigation('ReporteSocial')}>
            <Text style={styles.linkText}>REPORTES SOCIALES</Text>
          </TouchableOpacity>*/}
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={() => handleNavigation('PoliticasDevolucion')}>
            <Text style={styles.linkText}>TÉRMINOS Y CONDICIONES - POLÍTICAS DE DEVOLUCIÓN</Text>
          </TouchableOpacity>
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={handleOpenGiftcard}>
            <Text style={styles.linkText}>GIFTCARD - TÉRMINOS Y CONDICIONES </Text>
          </TouchableOpacity>
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={handleOpenCV}>
            <Text style={styles.linkText}>ENVIANOS TU CV</Text>
          </TouchableOpacity>
          <Text style={styles.sep}>·</Text>
          <TouchableOpacity onPress={openArrepentimiento}>
            <Text style={styles.linkText}>ARREPENTIMIENTO DE COMPRA</Text>
          </TouchableOpacity>
        </View>

      {/* Información de empresa y certificación */}
        <View style={styles.bottomInfo}>
          <Text style={styles.bottomInfoText}>
            CORMORAN S.A. · SERVICIO MAYORISTA
          </Text>
          <Text style={styles.bottomInfoText}>
            Av. Mitre 823 (2300) Rafaela, Santa Fe · 0800-144-5555 · info@cormoran.com.ar
          </Text>
          <Text style={styles.sslText}>Certificado SSL, Argentina</Text>
        </View>
      </View>

      {/* Modal Arrepentimiento de compra */}
      <Modal visible={showArrepModal} animationType="fade" transparent onRequestClose={closeArrepentimiento}>
        <View style={styles.modalBackdrop}>
          <View style={styles.modalCard}>
            <ScrollView contentContainerStyle={{ paddingBottom: 8 }}>
              <Text style={styles.modalTitle}>Arrepentimiento de compra</Text>
              {enviado ? (
                <>
                  <Text style={styles.modalText}>Recibimos tu solicitud de arrepentimiento de compra.</Text>
                  <Text style={styles.modalText}>Pedido/Comprobante: <Text style={styles.bold}>{pedido}</Text></Text>
                  <Text style={styles.modalText}>Te enviamos un email confirmando la baja del pedido.</Text>
                  <Text style={styles.modalText}>El dinero se devolverá y acreditará en unas horas.</Text>
                </>
              ) : (
                <>
                  <View style={styles.formGroup}>
                    <Text style={styles.modalLabel}>Nombre y apellido</Text>
                    <TextInput style={styles.modalInput} value={nombre} onChangeText={setNombre} placeholder="Tu nombre y apellido" placeholderTextColor="#9aa0a6" />
                  </View>
                  <View style={styles.formGroup}>
                    <Text style={styles.modalLabel}>Email o teléfono de contacto</Text>
                    <TextInput style={styles.modalInput} value={contacto} onChangeText={setContacto} placeholder="email@dominio.com o +54 9 ..." placeholderTextColor="#9aa0a6" />
                  </View>
                  <View style={styles.formGroup}>
                    <Text style={styles.modalLabel}>Número de pedido o comprobante de compra</Text>
                    <TextInput style={styles.modalInput} value={pedido} onChangeText={setPedido} placeholder="Ej: #A12345 / 0001-00001234" placeholderTextColor="#9aa0a6" />
                  </View>
                  {error ? <Text style={[styles.modalText, { color: '#b00020' }]}>{error}</Text> : null}
                </>
              )}
            </ScrollView>
            <View style={styles.modalButtonsRow}>
              <TouchableOpacity onPress={closeArrepentimiento} style={[styles.modalBtn, styles.modalBtnSecondary]}>
                <Text style={styles.modalBtnTextSecondary}>Cerrar</Text>
              </TouchableOpacity>
              {!enviado && (
                <TouchableOpacity onPress={handleEnviarArrep} style={[styles.modalBtn, styles.modalBtnPrimary]} disabled={enviando}>
                  <Text style={styles.modalBtnTextPrimary}>{enviando ? 'Enviando...' : 'Enviar'}</Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    //marginTop: 30,
  },
  topBorder: {
    width: '100%',
    height: 4,
    backgroundColor: colores.rojo,
  },
  darkArea: {
    width: '100%',
    backgroundColor: '#2b2b2b',
    paddingTop: 22,
    paddingBottom: 18,
    paddingHorizontal: layout.contentPadding,
    alignItems: 'center',
  },
  linksRow: {
    maxWidth: 1100,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  linkText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.3,
  },
  sep: {
    color: '#fff',
    opacity: 0.7,
    marginHorizontal: 6,
    fontSize: 12,
    fontWeight: '700',
  },
  bottomInfo: {
    marginTop: 16,
    maxWidth: 1100,
    alignItems: 'center',
    gap: 4,
  },
  bottomInfoText: {
    color: '#d6d6d6',
    fontSize: 12,
    textAlign: 'center',
  },
  sslText: {
    marginTop: 8,
    color: '#bdbdbd',
    fontSize: 11,
    textAlign: 'center',
  },
  // Modal styles
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
  },
  modalCard: {
    width: '100%',
    maxWidth: 640,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '700',
    marginBottom: 12,
  },
  modalText: {
    color: '#333',
    marginBottom: 6,
    fontSize: 14,
  },
  formGroup: {
    marginBottom: 10,
  },
  modalLabel: {
    fontSize: 13,
    fontWeight: '600',
    marginBottom: 4,
  },
  modalInput: {
    borderWidth: 1,
    borderColor: '#d0d7de',
    borderRadius: 6,
    paddingHorizontal: 10,
    paddingVertical: 9,
    fontSize: 14,
  },
  modalButtonsRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8,
  },
  modalBtn: {
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 6,
  },
  modalBtnSecondary: {
    backgroundColor: '#e9ecef',
  },
  modalBtnPrimary: {
    backgroundColor: colores.rojo,
  },
  modalBtnTextSecondary: {
    color: '#333',
    fontWeight: '600',
  },
  modalBtnTextPrimary: {
    color: '#fff',
    fontWeight: '700',
  },
  bold: {
    fontWeight: '700',
  }
});

export default Footer;